import type { Tracker } from '@dialogue/active-minutes'

interface TrackerAccumulator {
  [provider: string]: Tracker
}

export const filterLatestConnections = (connectedTrackers: Tracker[]): Tracker[] =>
  Object.values(
    connectedTrackers.reduce<TrackerAccumulator>((acc, item: Tracker) => {
      // @ts-expect-error FIXME: last_synced_at is nullable
      if (!acc[item.provider] || item.last_synced_at > acc[item.provider].last_synced_at) {
        acc[item.provider] = item
      }
      return acc
    }, {})
  )
